<template>
  <v-app :class="{ 'background-app': !$route.meta.whiteBackground }">

    <!-- test mode bar -->
    <v-system-bar v-if="$route.meta.displayNavigation && $store.state.ui.testMode" color="orange darken-3" dark app height="28" style="z-index: 101;">
      <v-spacer />
      <span class="body-2 font-weight-medium">Estás viendo datos de prueba. Los cambios aquí no afectan tus datos reales.</span>
      <v-spacer />
    </v-system-bar>
    <!-- end test mode bar -->

    <app-bar v-if="$route.meta.displayAppBar" style="z-index: 100;"/>

    <!-- menu -->
    <v-navigation-drawer class="white" v-if="$route.meta.displayNavigation" app clipped fixed mini-variant mini-variant-width="60" mobile-breakpoint style="overflow: visible !important; z-index: 99;">
      <v-list>
        <v-list-item @click="goTo(link.link)" :to="link.link !== 'DashboardUpdate' ? { name: `${link.link}` } : newRoute" v-for="link in items.slice(0,8)" :key="link.title" @click.stop="drawer = !['AccountDashboard', 'Integrations'].includes(selectedIcon)">
          <v-tooltip right transition="scale-transition">
            <template v-slot:activator="{on}">
              <v-col v-on="on">
                <img :src="selectedIcon === link.link ? require(`@/assets/appIcon-menu--${link.icon}--active.svg`) : require(`@/assets/appIcon-menu--${link.icon}.svg`)" width="34">
              </v-col>
            </template>
            <span class="font-weight-medium">{{link.title}}</span>
          </v-tooltip>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <v-list dense>
          <v-list-item :to="{ name: `${items[8].link}` }" class="mb-4" @click.stop="drawer = !['AccountDashboard', 'Integrations'].includes(selectedIcon)">
            <v-tooltip right transition="scale-transition">
              <template v-slot:activator="{on}">
                <v-col cols="12" justify="center" v-on="on">
                  <img :src="selectedIcon === items[8].link ? require('@/assets/appIcon-menu--Settings--active.svg') : require('@/assets/appIcon-menu--Settings.svg')" width="34">
                </v-col>
              </template>
              <span class="font-weight-medium">Configuración de la organización</span>
            </v-tooltip>
          </v-list-item>
        </v-list>
      </template>

      <!-- drawer open action -->
      <div class="v-navigation-drawer__handler right" @click="drawer=!drawer" v-if="!drawer && $route.meta.displayNavigationDrawer"></div>
      <!-- end drawer open action -->

    </v-navigation-drawer>
    <!-- end menu -->

    <!-- menu items -->
    <v-navigation-drawer class="px-3" v-model="drawer" v-if="$route.meta.displayNavigationDrawer" app clipped elevation="1" fixed hide-overlay stateless width="260px">
      <v-list dense nav class="v-list-drawer" style="padding-left: 60px;">
        <v-subheader class="mt-3 px-0 subtitle-1 font-weight-medium">{{selectedOption.title}}</v-subheader>

        <!-- options list -->
        <v-list-item-group>
          <template v-for="option in selectedOption.options">

            <template v-if="option.isFreeComponent">
              <!-- is free component menus -->
              <dashboard-drop-down v-if="option.component === 'DashboardDropDown'" :key="`${option.compoment}-menu`" />
              <metrics-drop-down v-if="option.component === 'MetricsDropDown'" :key="`${option.compoment}-menu`" />
              <!-- end is free component menus -->
            </template>

            <v-list-item v-else-if="option.link" color="primary" :key="`${option.link}-link`" :ripple="false" :to="{ name: option.link }">
              <v-list-item-content class="py-0">
                <v-list-item-title class="text-none subtitle-2 font-weight-medium">{{ option.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-subheader v-else class="mt-6 px-0 subtitle-2 font-weight-medium" :key="`${option.link}-title`">{{option.title}}</v-subheader>

            <!-- sub menu -->
            <v-list-item class="pl-6 nl-2" v-for="o in option.options" exact :key="`${o.link}-option`" :ripple="false" :to="{ name: o.link }">
              <v-list-item-title class="body-2">{{o.title}}</v-list-item-title>
            </v-list-item>
            <!-- end sub menu -->

          </template>
        </v-list-item-group>
        <!-- end options list -->
      </v-list>

      <!-- drawer close action -->
      <div class="v-navigation-drawer__handler left" @click="drawer=!drawer" v-if="drawer && $route.meta.displayNavigationDrawer"></div>
      <!-- end drawer close action -->

    </v-navigation-drawer>
    <!-- end menu items -->

    <!-- quickstart drawer -->
    <v-navigation-drawer v-if="$route.meta.displayNavigation && $store.state.auth.account.id" :value="$store.state.ui.quickstartDrawer" @input="$store.commit('ui/TOGGLE_QUICKSTART_DRAWER', $event)" clipped fixed right stateless width="360" :style="{ 'z-index': 98, top: quickstartDrawerTop + 'px', height: 'calc(100vh - ' + quickstartDrawerTop + 'px)' }">
      <quickstart-drawer @close="$store.commit('ui/TOGGLE_QUICKSTART_DRAWER', false)" />
    </v-navigation-drawer>
    <!-- end quickstart drawer -->

    <!-- view -->
    <v-main :class="drawerStateClass" :style="quickstartDrawerStyle">
      <v-container :class="{ 'pa-0': !$route.meta.requireAuth }" fluid>
        <router-view :key="$route.fullPath + '_' + $store.state.ui.testMode"></router-view>
      </v-container>
    </v-main>
    <!-- end view -->

  </v-app>
</template>
<script>
import AppBar from '@/components/menu/AppBar'
import DashboardDropDown from '@/components/menu/DashboardDropDown'
import MetricsDropDown from '@/components/menu/MetricsDropDown'
import QuickstartDrawer from '@/components/onboarding/QuickstartDrawer'

import items from '@/collections/menu-items'

export default {
  components: {
    AppBar,
    DashboardDropDown,
    MetricsDropDown,
    QuickstartDrawer
  },
  data: () => ({
    currentOption: {
      title: 'Dashboard',
      icon: 'AccountDashboard',
      link: 'AccountDashboard'
    },
    drawer: true,
    items: items,
    newRoute: '',
    selectedIcon: 'AccountDashboard'
  }),
  watch: {
    $route: {
      immediate: false,
      handler: function (to, from) {
        this.selectedIcon = to.meta.parent
        this.drawer = !this.hiddenDrawer.includes(to.name)

        if (to.path !== from.path) {
          this.$vuetify.goTo(1, { duration: '0', easing: 'linear' })
        }
      }
    }
  },
  mounted: function () {
    this.selectedIcon = this.$route.meta.parent

    this.$nextTick(() => {
      this.drawer = !this.hiddenDrawer.includes(this.$route.name)
    })
  },
  computed: {
    drawerStateClass () {
      /**
       * Returns the class for the main view depending on
       * the state of the navigation drawer, whether it's
       * shown, hidden, or reduced.
       */
      if (!this.$route.meta.displayNavigationDrawer) {
        return 'v-navigation-drawer-hidden'
      }

      if (this.drawer) {
        return 'v-navigation-drawer-extended'
      } else {
        return 'v-navigation-drawer-reduced'
      }
    },
    hiddenDrawer () {
      /**
       * Returns an array of route names where the navigation
       * drawer should be hidden.
       */
      return this.$router.options.routes.filter(r => !r.meta.displayNavigationDrawer).map(r => r.name)
    },
    quickstartDrawerTop () {
      const appBarHeight = 64
      const systemBarHeight = this.$store.state.ui.testMode && this.$route.meta.displayAppBar ? 28 : 0
      return appBarHeight + systemBarHeight
    },
    quickstartDrawerStyle () {
      if (this.$store.state.ui.quickstartDrawer && this.$route.meta.displayNavigation && this.$store.state.auth.account.id) {
        return { 'padding-right': '360px' }
      }
      return {}
    },
    selectedOption () {
      /**
       * Returns the currently selected menu option based on
       * the selected icon of the navigation.
       */
      return this.items.find(item => item.link === this.selectedIcon) || {}
    }
  },
  methods: {
    isSelected (name) {
      return this.$route.matched.some(item => item.name === name)
    },
    goTo (link) {
      if (link === 'DashboardUpdate') {
        this.$store.dispatch('dashboards/LIST', {
          resource: 'metrics/dashboards'
        })
        .then((response) => {
          if (response.data.results.length) {
           this.newRoute = '/dashboard/' + response.data.results[0].id + '/edit'
            this.$router.push({
              name: 'DashboardUpdate',
              params: {
                id: response.data.results[0].id
              }
            })
            .catch(err => err)
          } else {
            this.newRoute = '/dashboards'
            this.$router.push('/dashboards').catch(err => err)
          }
        })
      }
    }
  }
}
</script>
<style scoped>
.v-navigation-drawer-hidden {
  padding-left: 70px !important;
}

.v-navigation-drawer-extended {
  padding-left: 280px !important;
}

.v-navigation-drawer-reduced {
  padding-left: 80px !important;
}
</style>